export const PF_SURVEY_WHY_REMOVING_COMMUNITY = 'c037a1a8-bf57-40dc-a639-498edb6def1f'
